import React from 'react';

const Location = () => {
  return (
    <section id="location" className="location-section">
      <div className="container">
        
        {/* Header matching Emergent design */}
        <div className="location-header">
          <p className="location-subtitle">VISIT US</p>
          <h2 className="location-title">Our Location</h2>
          <p className="location-desc">
            Come visit us and experience authentic chai in a warm, welcoming atmosphere
          </p>
        </div>

        <div className="location-grid">
          
          {/* Left Side: The Map */}
          <div className="location-map-wrapper">
            <iframe 
              title="ChaiY Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.560155097893!2d73.81232!3d18.50355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDMwJzEyLjgiTiA3M8KwNDgnNDQuNCJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin" 
              style={{ border: 0, width: '100%', height: '100%', borderRadius: '16px' }} 
              allowFullScreen="" 
              loading="lazy">
            </iframe>
          </div>

          {/* Right Side: Info Cards */}
          <div className="location-info-stack">
            
            {/* Primary Info Card */}
            <div className="info-card">
              
              <div className="info-row">
                <div className="icon-circle">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                </div>
                <div className="info-text">
                  <h4>Address</h4>
                  <p>Dahanukar Colony, Kothrud, Pune</p>
                </div>
              </div>

              <div className="info-row">
                <div className="icon-circle">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                </div>
                <div className="info-text">
                  <h4>Phone</h4>
                  <p>8080673114</p>
                </div>
              </div>

              <div className="info-row">
                <div className="icon-circle">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <div className="info-text">
                  <h4>Hours</h4>
                  <p>Monday - Friday: 8:00 AM - 10:00 PM<br/>Saturday - Sunday: 8:00 AM - 11:00 PM</p>
                </div>
              </div>

            </div>

            {/* Get Directions Button */}
            <a href="https://maps.google.com/?q=Dahanukar+Colony+Kothrud+Pune" target="_blank" rel="noreferrer" className="btn-primary btn-directions">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '8px'}}><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>
              Get Directions
            </a>

            {/* Why Visit Us Card */}
            <div className="perks-card">
              <h4>Why Visit Us?</h4>
              <ul>
                <li>Free parking available</li>
                <li>Cozy seating area</li>
                <li>Sample our chai varieties</li>
                <li>Take-home premixes available</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;